import clsx from "clsx";
import { Theme } from "apps/website/maps/Theme.map";

import { AccordionType } from "./Accordion.map";

export const getButtonClasses = (type: AccordionType, theme?: Theme) => {
  const classes: string[] = [];
  if ([ "default", "footer", "full-border", "preview" ].includes(type)) {
    classes.push("justify-between");
  } else {
    classes.push("justify-center overflow-hidden");
  }

  if (type === "default" && theme) {
    classes.push("px-4");
  }

  return classes.join(" ");
};

export const getButtonTextClasses = (type: AccordionType) => (
  clsx(
    type === "underline" && "underline",
    type === "preview" && "flex items-center",
    type === "horizontal-rule" && "relative before:-translate-x-[calc(100%+16px)] before:absolute before:top-1/2  before:block before:w-screen before:h-0.5 before:bg-black underline",
    "w-fit max-w-[200px] md:max-w-[400px]",
  )
);

export const getIconRotationClasses = (isAccordionOpen: boolean) => (isAccordionOpen ? "-rotate-180" : "rotate-0");

export const getPreviewOpacityRotationClasses = (isAccordionOpen: boolean) => (isAccordionOpen ? "opacity-100" : "opacity-0");

export const getHorizontalRuleClasses = (type: AccordionType) => {
  if (type !== "horizontal-rule") { return; }
  return "relative after:ml-4 after:right-0 after:translate-x-[calc(100%+16px)] after:absolute after:top-1/2 after:block after:w-screen after:h-0.5 after:bg-black";
};

export const getChildrenClasses = (type: AccordionType, isAccordionOpen: boolean) => {
  if (type !== "preview") { return; }
  return `transition-opacity duration-300 ease-in-out ${getPreviewOpacityRotationClasses(isAccordionOpen)}`;
};
